// Tipos de lastro do recebível (item 23c) — CONSTANTE ÚNICA do front,
// consumida pelo wizard de Nova Operação E pelo Estoque (antes o Stock.jsx
// tinha uma lista própria com só 6 tipos, sem label).
//
// ESPELHO MANUAL da V2: a FONTE é BACKING_TYPE_LABELS em
// ~/zemo/v2/backend/app/domain/contract_builder.py (enum
// receivable_backing_type do banco, 25 valores + labels PT-BR). A V2 valida
// fail-closed no create (valor fora do enum ⇒ 422 com a lista válida); aqui
// é só EXIBIÇÃO — se a V2 ganhar o 26º tipo, o sync é manual (atualizar este
// arquivo E o pin em backingTypes.test.js).
export const BACKING_TYPE_LABELS = {
  NFE: "NF-e",
  NFSE: "NFS-e",
  CTE: "CT-e",
  COMMERCIAL_CONTRACT: "Contrato Performado",
  COMMERCIAL_NOTE: "Nota Comercial",
  SERVICE_ORDER: "Ordem de Servico",
  DUTY_SHIFT: "Escala",
  TRADE_BILL: "Duplicata",
  PROMISSORY_NOTE: "Nota Promissoria",
  PUBLIC_PAYROLL_MARGIN: "Margem Consignavel Publica",
  PRIVATE_PAYROLL_MARGIN: "Margem Consignavel Privada",
  SALARY_ADVANCE: "Antecipacao Salarial",
  RECURRING_CONTRACT: "Contrato Recorrente",
  UNPERFORMED_CONTRACT: "Contrato Nao Performado",
  SIGNED_PURCHASE_ORDER: "Pedido Assinado",
  DELIVERY_PROOF: "Comprovante de Entrega",
  PAYER_ACCEPTANCE_WITH_AGREEMENT: "Aceite com Convenio",
  PAYER_ACCEPTANCE_WITHOUT_AGREEMENT: "Aceite sem Convenio",
  BOLETO: "Boleto",
  MEASUREMENT_REPORT: "Medicao",
  INVOICE: "Fatura",
  MEDICAL_CONTRACT: "Contrato Medico",
  PRODUCTION_REPORT: "Producao",
  RECEIVABLE_EVIDENCE: "Evidencia do Recebivel",
  OTHER: "Outro",
};

// Opções na ORDEM DE DECLARAÇÃO da V2 (NFE primeiro) — é o array que os
// Selects (wizard e estoque) mapeiam 1:1 em <SelectItem>.
export const BACKING_TYPE_OPTIONS = Object.entries(BACKING_TYPE_LABELS).map(
  ([value, label]) => ({ value, label })
);

// Default histórico: antes do item 23c todo recebível nascia "NFE" na V2
// (espelho de DEFAULT_BACKING_TYPE do contract_builder.py — compat com o
// comportamento atual do create).
export const DEFAULT_BACKING_TYPE = "NFE";

// Label de EXIBIÇÃO: valor desconhecido (ex.: 26º tipo criado na V2 antes do
// sync manual) cai no próprio código cru — nunca esconde o dado.
export function backingTypeLabel(value) {
  if (!value) return "--";
  return BACKING_TYPE_LABELS[value] || value;
}
